/**
 * @generated SignedSource<<a6a2052391de1da14161c94a11150054>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateEditChannelModalInitializationQuery$variables = {};
export type CreateEditChannelModalInitializationQuery$data = {
  readonly viewer: {
    readonly autoPublishRecordingSettings: {
      readonly enabled: boolean;
      readonly externalRecordingsChannel: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly internalRecordingsChannel: {
        readonly id: string;
      } | null;
    } | null;
  };
};
export type CreateEditChannelModalInitializationQuery = {
  response: CreateEditChannelModalInitializationQuery$data;
  variables: CreateEditChannelModalInitializationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "UserRecordingAutoPublishSettings",
  "kind": "LinkedField",
  "name": "autoPublishRecordingSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "externalRecordingsChannel",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "internalRecordingsChannel",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEditChannelModalInitializationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateEditChannelModalInitializationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae4a84dffd4daf6dd0a5f2fd140203c0",
    "id": null,
    "metadata": {},
    "name": "CreateEditChannelModalInitializationQuery",
    "operationKind": "query",
    "text": "query CreateEditChannelModalInitializationQuery {\n  viewer {\n    autoPublishRecordingSettings {\n      id\n      enabled\n      externalRecordingsChannel {\n        id\n      }\n      internalRecordingsChannel {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "428c6c62755bf6c77f626dc3c33f67a0";

export default node;
